export const isSeriesRef = (ref) => ref.kind === "series";
export const isSummaryRef = (ref) => ref.kind === "summary";
export function* updatesOf(updates, kind) {
    for (const entry of updates) {
        if ((entry[0].kind ?? "curve") === kind)
            yield entry;
    }
}
//# sourceMappingURL=watchRef.js.map